package features.attendance.handlers

import AppState
import Router
import features.attendance.domain.Holiday
import kotlin.js.Date

object HolidayHandlers {
    fun addHoliday(teamId: String, date: String, name: String, description: String) {
        console.log("➕ Adding holiday:", name, "on", date)
        
        val holidays = AppState.holidays[teamId] ?: mutableListOf()
        val newId = "h${Date().getTime().toLong()}"
        
        holidays.add(Holiday(newId, date, name, description))
        AppState.holidays[teamId] = holidays
        
        console.log("✅ Holiday added successfully")
        Router.render()
    }
    
    fun editHoliday(teamId: String, holidayId: String, date: String, name: String, description: String) {
        console.log("✏️ Editing holiday:", holidayId)
        
        val holidays = AppState.holidays[teamId] ?: return
        val index = holidays.indexOfFirst { it.id == holidayId }
        
        if (index != -1) {
            holidays[index] = Holiday(holidayId, date, name, description)
            console.log("✅ Holiday updated successfully")
            Router.render()
        }
    }
    
    fun deleteHoliday(teamId: String, holidayId: String) {
        console.log("🗑️ Deleting holiday:", holidayId)
        
        val confirmed = kotlinx.browser.window.confirm("Are you sure you want to delete this holiday?")
        if (!confirmed) return
        
        val holidays = AppState.holidays[teamId]?.toMutableList() ?: return
        val filtered = holidays.filter { it.id != holidayId }.toMutableList()
        AppState.holidays[teamId] = filtered
        
        console.log("✅ Holiday deleted successfully")
        Router.render()
    }
}
